import { logWrapper } from '../../utils';
import toastr from 'toastr';

export default {
  notificationsController: [
    'runtimeConstant',
    '$scope',
    '$rootScope',
    '$filter',
    '$state',
    'authService',
    'notificationService',
    function (
      runtimeConstant,
      $scope,
      $rootScope,
      $filter,
      $state,
      authService,
      notificationService
    ) {
      'use strict';

      function redirect(type) {
        switch (type) {
          case 3:
            $state.go('home.myDeadLines', { page: 1 });
            break;
          case 4:
            $state.go('flows.base.tasks');
            break;
          case 5:
            $state.go('flows.base.tasks');
            break;
          case 6:
            $state.go('home.shareds', { page: 1 });
            break;
        }
      }

      function onAlterNotification() {
        notificationService.getMessages().then((res) => {
          if (res.NotificationPush.length < 10) {
            $scope.showLoadMore = false;
          } else {
            $scope.showLoadMore = true;
          }

          $scope.getItems = res.NotificationPush;

          $scope.notification = res.Count;
        });
      }

      function showNotification(level, msg) {
        toastr.options = {
          closeButton: true,
          debug: false,
          progressBar: false,
          preventDuplicates: false,
          positionClass: 'toast-top-right',
          showDuration: '1000',
          hideDuration: '1000',
          timeOut: '7000',
          extendedTimeOut: '1000',
          showEasing: 'swing',
          hideEasing: 'linear',
          showMethod: 'fadeIn',
          hideMethod: 'fadeOut',
        };

        toastr[level]($filter('translate')(msg));
      }

      function redirectNotification(id, type, status) {
        if (status === 1) {
          redirect(type);
        } else {
          notificationService.viewNotification(id).then((data) => {
            if (data === 'Sucesso') {
              redirect(type);
              $scope.$emit('alterNotification');
            }
          });
        }
      }

      function UpdateStatusNotification() {
        notificationService.updateStatusNotification().then((res) => {
          if (res === 'Sucesso') {
            $scope.$emit('alterNotification');
          }
        });
      }

      function loadMoreNotifications() {
        var min = Math.min(...$scope.getItems.map((item) => item.Id));

        notificationService.loadMore(min).then((res) => {
          if (res.length < 10) {
            $scope.showLoadMore = false;
          } else {
            $scope.showLoadMore = true;
          }

          angular.forEach(res, function (res) {
            $scope.getItems.push(res);
          });

          $scope.notification = res.filter(function (obj) {
            return obj.Status === 0;
          }).length;
        });
      }

      function run() {
        try {
          $scope.showLoadMore = false;

          if ($scope.notification === undefined) {
            notificationService.getMessages().then((res) => {
              if (
                res.NotificationPush.length === 10 ||
                res.NotificationPush === undefined
              ) {
                $scope.showLoadMore = true;
              } else {
                $scope.showLoadMore = false;
              }

              $scope.getItems = res.NotificationPush;

              var lastId = 0;
              if (res.NotificationPush.length > 0) {
                lastId = res.NotificationPush[0].Id;
              }

              $scope.notification = res.Count;

              if ($rootScope.user !== null)
                notificationService.getNotification(
                  $rootScope.user.id,
                  authService.getLoggedCompany().IdCompany,
                  lastId
                );
            });
          }

          $rootScope.$on(
            'alterNotification',
            logWrapper(
              onAlterNotification,
              runtimeConstant.isDebugControllersInternals
            )
          );
          $rootScope.showNotification = logWrapper(
            showNotification,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.redirectNotification = logWrapper(
            redirectNotification,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.UpdateStatusNotification = logWrapper(
            UpdateStatusNotification,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.loadMoreNotifications = logWrapper(
            loadMoreNotifications,
            runtimeConstant.isDebugControllersInternals
          );
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      logWrapper(run, runtimeConstant.isDebugControllers)();
    },
  ],
};
